<script>
	//Hooks
	import { beforeUpdate } from 'svelte';
	import { devices_config } from '@devices/index';
	//Helpers
	import { real_id, get_mode } from '../../../helpers/interface_helpers';
	import {
		updateSingleChannelInterfaceData,
		deleteAllChannelsInterfaceData,
	} from '../../../helpers/add_delete_helpers';
	//Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Button, Text } from '@Shelly/shelly-design-system';

	$: statusStore = getDeviceStatus(device.id);
	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let status, settings, mode, is_split;

	beforeUpdate(() => {
		status = $statusStore;
		settings = $settingsStore;
		is_split = typeof $devices[real_id(device.id) + '_1'] !== 'undefined';
		if (
			status?.online &&
			typeof settings !== 'undefined' &&
			typeof devices_config[device?.type] !== 'undefined'
		) {
			mode = get_mode(device, status, settings);
		}
	});

	const test_split = async () => {
		if (is_split) {
			await deleteAllChannelsInterfaceData(device);
			await save_one_channel_data();
		} else {
			for (let i = 0; i < devices_config[device.type].modes?.[mode].phases; i++) {
				const device_tmp = Object.assign({}, device);

				if (i > 0) {
					device_tmp.id = `${device.id}_${i}`;
					device_tmp.name = `${device.name} ${i + 1}`;
					device_tmp.channel = i;
				}
				device_tmp.channels_count = 3;
				device_tmp.split = true;

				device_tmp.position;
				// mok_device.type = 'ext_sensor';
				console.log('device_tmp', device_tmp);
				await updateSingleChannelInterfaceData(device_tmp);
			}
		}
	};

	const save_one_channel_data = async () => {
		const device_tmp = Object.assign({}, device);
		device_tmp.name = device.name.replace(/\s\d/, '');
		device_tmp.id = real_id(device_tmp.id);
		device_tmp.channels_count = 1;
		device_tmp.channel = 0;
		device_tmp.split = false;

		return await updateSingleChannelInterfaceData(device_tmp);
	};
</script>

{#if is_split}
	<Text styleType="body-small" class="mb-s"
		>Combind devices (pahses/clamps) back into one. Usefull in this... and this case</Text
	>
{:else}
	<Text styleType="body-small" class="mb-s"
		>Split device into 3 (One device for each phase/clamp). Use full in this... and this case.</Text
	>
{/if}

<Button size="m" width="full" on:click={test_split}
	>{is_split ? 'combind devices into one' : 'split to single devices'}</Button
>
